import React from "react";
import { Route, Switch } from "react-router";
import { AnalyticsIndex } from "../../../pages/admin/analytics";

export const AdminAnalyticsRoutes = (
  <Switch>
    <Route
      exact
      path="/v2/admin/analytics"
      component={AnalyticsIndex} />
  </Switch>
);
